
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ffp8s", function(module, exports) {
$parcel$export(module.exports, "AnalyticsByLine", () => (parcelRequire("cXNn3")).AnalyticsByLine);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cXNn3 = parcelRequire("cXNn3");


});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("aXes4", function(module, exports) {
var $4de63777257ade50$export$64176d052f399149 = /*#__PURE__*/ function(SSREvent) {
    SSREvent["CLICK"] = "click";
    SSREvent["HOVER"] = "hover";
    SSREvent["FOCUS"] = "focus";
    return SSREvent;
}({});
module.exports["SSREvent"] = $4de63777257ade50$export$64176d052f399149;

});

parcelRegister("jHois", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");

const $e3adf083a3ceeb07$export$3cf4b7499c49a1bc = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY)
});
const $e3adf083a3ceeb07$export$f38e95ed03e5cac6 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_INTERACTION)
});
const $e3adf083a3ceeb07$export$fe68f7d0c5f4b391 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION)
});
const $e3adf083a3ceeb07$export$f35c906f54c0512a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.PAGE_ANALYTICS_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$aa2d84a67f31f760 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SPACE_ANALYTICS_PAGE_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$73b0f2ef62226204 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SITE_ANALYTICS_LOAD_KEY)
});
module.exports["CONTENT_ANALYTICS_VIEWERS_METRIC"] = $e3adf083a3ceeb07$export$3cf4b7499c49a1bc;
module.exports["CONTENT_ANALYTICS_DIALOG_METRIC"] = $e3adf083a3ceeb07$export$f38e95ed03e5cac6;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_METRIC"] = $e3adf083a3ceeb07$export$fe68f7d0c5f4b391;
module.exports["PAGE_ANALYTICS_PAGE_LOAD_METRIC"] = $e3adf083a3ceeb07$export$f35c906f54c0512a;
module.exports["SPACE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$aa2d84a67f31f760;
module.exports["SITE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$73b0f2ef62226204;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("jrT4o", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $8afb2f770e824490$export$42a852a2b6b56249 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4v47k _2rkofajl _1bsb1kdj _1e0c1txw _2lx21bp4 _vchhusvi _kqswh2mm _1reo15vq _bfhk1bhr _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4v47k _2rkofajl _1bsb1kdj _1e0c1txw _2lx21bp4 _vchhusvi _kqswh2mm _1reo15vq _bfhk1bhr _16qs130s",
            __cmplp.className
        ])
    });
});
const $8afb2f770e824490$export$dbb670aba77d71f1 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { zIndex: zIndex, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, $9aYkv.default)(__cmplp.zIndex)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_kqswstnw _1e0cglyw _19pk12x7 _1pby1fcb",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $9aYkv.default)(__cmplp.zIndex)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_kqswstnw _1e0cglyw _19pk12x7 _1pby1fcb",
            __cmplp.className
        ])
    });
});
const $8afb2f770e824490$export$f407cfc3d51ce8f = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3i88uy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4t3i88uy",
            __cmplp.className
        ])
    });
});
const $8afb2f770e824490$export$14f034b425e26b9c = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8fhey _18s85uws _k48p1wq8 _1e0c1txw _1bah1h6o _y3gn1h6o _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _18s85uws _k48p1wq8 _1e0c1txw _1bah1h6o _y3gn1h6o _syazazsu",
            __cmplp.className
        ])
    });
});
const $8afb2f770e824490$export$17ad30a5502cf0d4 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
module.exports["Container"] = $8afb2f770e824490$export$42a852a2b6b56249;
module.exports["SSRContainer"] = $8afb2f770e824490$export$dbb670aba77d71f1;
module.exports["SSRChartSkeleton"] = $8afb2f770e824490$export$f407cfc3d51ce8f;
module.exports["SSRLoadingText"] = $8afb2f770e824490$export$14f034b425e26b9c;
module.exports["DialogCenteredRow"] = $8afb2f770e824490$export$17ad30a5502cf0d4;

});

parcelRegister("c98X8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gtMdU = parcelRequire("gtMdU");




















var $hekY6 = parcelRequire("hekY6");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $2e17dfeace5419a0$export$42a852a2b6b56249 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
            alignItems: "center",
            direction: "column"
        }, props.children);
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        alignItems: "center",
        direction: "column"
    }, props.children);
}; // No lint errors when composing a css style after the object, however we want this order of precedence
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $2e17dfeace5419a0$var$valueStyles = null; // There is no current Visual Refresh solution for headings with custom css and custom props.
const $2e17dfeace5419a0$export$4c8d1a57a761ef94 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_11c81iff _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pi7a9 _1e0c1txw _4cvr1h6o _4t3i1ylp _syazi7uo"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("span", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_11c81iff _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pi7a9 _1e0c1txw _4cvr1h6o _4t3i1ylp _syazi7uo"
        ])
    });
};
const $2e17dfeace5419a0$export$efdd3e096bc27746 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            size: "small"
        }, props.children);
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        size: "small"
    }, props.children);
};
const $2e17dfeace5419a0$var$skeletonBlockStyles = null;
const $2e17dfeace5419a0$export$fa18745101116729 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(11);
    let divProps;
    let height;
    let marginTop;
    if ($[0] !== props) {
        ({ height: height, marginTop: marginTop, ...divProps } = props);
        $[0] = props;
        $[1] = divProps;
        $[2] = height;
        $[3] = marginTop;
    } else {
        divProps = $[1];
        height = $[2];
        marginTop = $[3];
    }
    const t0 = `${height}px`;
    const t1 = `${marginTop}px`;
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = {
            height: t0,
            marginTop: t1
        };
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_2rkofajl _1e0c1txw _bfhkizff _1bsb1ylp _4cvr1h6o"
        ]);
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== divProps || $[9] !== t2) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...divProps,
            style: t2,
            className: t3
        });
        $[8] = divProps;
        $[9] = t2;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : (props)=>{
    const { height: height, marginTop: marginTop, ...divProps } = props;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ...divProps,
        style: {
            height: `${height}px`,
            marginTop: `${marginTop}px`
        },
        className: (0, $hekY6.default)([
            "_2rkofajl _1e0c1txw _bfhkizff _1bsb1ylp _4cvr1h6o"
        ])
    });
};


const $29942087abb457fd$var$skeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$fa18745101116729, {
    height: 28,
    marginTop: 4
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$fa18745101116729, {
    height: 14,
    marginTop: 8
}));
const $29942087abb457fd$var$formatAbbreviatedNumber = (locale, count)=>{
    try {
        const numberFormatter = Intl.NumberFormat(locale, {
            notation: 'compact',
            compactDisplay: 'short'
        });
        return numberFormatter.format(count).toLocaleLowerCase();
    } catch (e) {
        return `${count}`;
    }
};
const $29942087abb457fd$var$InfoPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { value: value, metric: metric, isLoading: isLoading, testId: testId } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== value) {
        t1 = typeof value === "number" ? $29942087abb457fd$var$formatAbbreviatedNumber(intl.locale, value) : value;
        $[0] = intl;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    const valueDisplay = t1;
    const testIdText = testId && isLoading ? `${testId}-skeleton` : testId;
    let t2;
    if ($[3] !== isLoading || $[4] !== metric || $[5] !== valueDisplay) {
        t2 = isLoading ? $29942087abb457fd$var$skeleton : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$4c8d1a57a761ef94, null, valueDisplay), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$efdd3e096bc27746, null, metric));
        $[3] = isLoading;
        $[4] = metric;
        $[5] = valueDisplay;
        $[6] = t2;
    } else t2 = $[6];
    const display = t2;
    let t3;
    if ($[7] !== display || $[8] !== testIdText) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testIdText
        }, display);
        $[7] = display;
        $[8] = testIdText;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ value: value, metric: metric, isLoading: isLoading, testId: testId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const valueDisplay = typeof value === 'number' ? $29942087abb457fd$var$formatAbbreviatedNumber(intl.locale, value) : value;
    const testIdText = testId && isLoading ? `${testId}-skeleton` : testId;
    const display = isLoading ? $29942087abb457fd$var$skeleton : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$4c8d1a57a761ef94, null, valueDisplay), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e17dfeace5419a0$export$efdd3e096bc27746, null, metric));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testIdText
    }, display);
};
var $29942087abb457fd$export$2e2bcd8739ae039 = $29942087abb457fd$var$InfoPanel;



var $cLD3i = parcelRequire("cLD3i");













const $078c4b1104938816$export$da940508739d3c23 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _19pkutpp _otyrpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _19pkutpp _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $078c4b1104938816$export$70694425b3deabac = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsbmgvx",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsbmgvx",
            __cmplp.className
        ])
    });
});


const $9f39c7e1f90d5562$export$a77e829434f1240e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isLoading: isLoading, viewsCount: viewsCount, uniqueViewsCount: uniqueViewsCount } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "confluence-analytics.metrics.views-all-time",
            defaultMessage: "views (all-time)"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== isLoading || $[2] !== viewsCount) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c4b1104938816$export$70694425b3deabac, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29942087abb457fd$export$2e2bcd8739ae039), {
            value: viewsCount,
            metric: t1,
            isLoading: isLoading,
            testId: (0, $cLD3i.TestId).INFO_PANEL_1
        }));
        $[1] = isLoading;
        $[2] = viewsCount;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "confluence-analytics.metrics.unique-viewers-all-time",
            defaultMessage: "unique viewers (all-time)"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading || $[6] !== uniqueViewsCount) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c4b1104938816$export$70694425b3deabac, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29942087abb457fd$export$2e2bcd8739ae039), {
            value: uniqueViewsCount,
            metric: t3,
            isLoading: isLoading,
            testId: (0, $cLD3i.TestId).INFO_PANEL_2
        }));
        $[5] = isLoading;
        $[6] = uniqueViewsCount;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c4b1104938816$export$da940508739d3c23, null, t2, t4);
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ isLoading: isLoading, viewsCount: viewsCount, uniqueViewsCount: uniqueViewsCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c4b1104938816$export$da940508739d3c23, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c4b1104938816$export$70694425b3deabac, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29942087abb457fd$export$2e2bcd8739ae039), {
        value: viewsCount,
        metric: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "confluence-analytics.metrics.views-all-time",
            defaultMessage: "views (all-time)"
        }),
        isLoading: isLoading,
        testId: (0, $cLD3i.TestId).INFO_PANEL_1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c4b1104938816$export$70694425b3deabac, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29942087abb457fd$export$2e2bcd8739ae039), {
        value: uniqueViewsCount,
        metric: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "confluence-analytics.metrics.unique-viewers-all-time",
            defaultMessage: "unique viewers (all-time)"
        }),
        isLoading: isLoading,
        testId: (0, $cLD3i.TestId).INFO_PANEL_2
    })));
module.exports["AnalyticsDialogInfoPanel"] = $9f39c7e1f90d5562$export$a77e829434f1240e;

});

parcelRegister("6rmEX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");











var $l8Rhq = parcelRequire("l8Rhq");


var $kz1Yj = parcelRequire("kz1Yj");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $cLo2u = parcelRequire("cLo2u");


var $1NBp8 = parcelRequire("1NBp8");

const $cbb8c99c53de7179$var$containerStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $cbb8c99c53de7179$var$AnchorStyles = (0, $buxP3.xcss)({
    width: '100%',
    textAlign: 'center',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    }
});
const $cbb8c99c53de7179$var$ViewMoreButtonStyles = (0, $buxP3.xcss)({
    width: '100%',
    height: '32px',
    borderRadius: 'radius.xsmall',
    textDecoration: 'none',
    backgroundColor: 'color.background.neutral',
    color: 'color.text',
    fontWeight: 'font.weight.medium',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $cbb8c99c53de7179$export$b5022d69a013cca3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, contentTab: contentTab, onClick: onClick, testId: testId, children: children } = t0;
    const spaceKey = (0, $cLo2u.useSpaceKey)() || "";
    if (!spaceKey || !contentId) return null;
    let t1;
    if ($[0] !== contentId || $[1] !== contentTab || $[2] !== spaceKey) {
        t1 = (0, $1NBp8.PAGE_ANALYTICS).toUrl({
            spaceKey: spaceKey,
            contentId: contentId,
            tab: contentTab ? contentTab.toLowerCase() : undefined
        });
        $[0] = contentId;
        $[1] = contentTab;
        $[2] = spaceKey;
        $[3] = t1;
    } else t1 = $[3];
    const pageAnalyticsURL = t1;
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $cbb8c99c53de7179$var$ViewMoreButtonStyles,
            alignInline: "center",
            alignBlock: "center"
        }, children);
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== onClick || $[7] !== pageAnalyticsURL || $[8] !== t2 || $[9] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            paddingBlockStart: "space.200",
            xcss: $cbb8c99c53de7179$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
            href: pageAnalyticsURL,
            onClick: onClick,
            testId: testId,
            xcss: $cbb8c99c53de7179$var$AnchorStyles
        }, t2));
        $[6] = onClick;
        $[7] = pageAnalyticsURL;
        $[8] = t2;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ contentId: contentId, contentTab: contentTab, onClick: onClick, testId: testId, children: children })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)() || ``;
    // spaceKey and contentId are required for PAGE_ANALYTICS.toUrl
    if (!spaceKey || !contentId) return null;
    const pageAnalyticsURL = (0, $1NBp8.PAGE_ANALYTICS).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        tab: contentTab ? contentTab.toLowerCase() : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        paddingBlockStart: "space.200",
        xcss: $cbb8c99c53de7179$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
        href: pageAnalyticsURL,
        onClick: onClick,
        testId: testId,
        xcss: $cbb8c99c53de7179$var$AnchorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $cbb8c99c53de7179$var$ViewMoreButtonStyles,
        alignInline: "center",
        alignBlock: "center"
    }, children)));
};



var $cLD3i = parcelRequire("cLD3i");


var $6eE4L = parcelRequire("6eE4L");











var $hekY6 = parcelRequire("hekY6");

const $4103eac0db9bd496$export$651095642c93be3d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});


const $f5795ebaaf370945$var$i18n = (0, $kSwu1.defineMessages)({
    viewMoreInsightsButton: {
        id: "confluence-analytics.view-more-insights.button",
        defaultMessage: "View more insights"
    }
});
const $f5795ebaaf370945$export$a856abee04b676b5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { isLoading: isLoading, contentId: contentId, contentTab: contentTab, onClickAnalyticsLink: onClickAnalyticsLink } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== contentTab || $[2] !== isLoading || $[3] !== onClickAnalyticsLink) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eE4L.AnalyticsDialogFooterSkeleton), {
            "data-testid": (0, $cLD3i.TestId).LINK_SKELETON
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4103eac0db9bd496$export$651095642c93be3d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbb8c99c53de7179$export$b5022d69a013cca3), {
            contentId: contentId,
            contentTab: contentTab,
            testId: (0, $cLD3i.TestId).LINK,
            onClick: onClickAnalyticsLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f5795ebaaf370945$var$i18n.viewMoreInsightsButton))));
        $[0] = contentId;
        $[1] = contentTab;
        $[2] = isLoading;
        $[3] = onClickAnalyticsLink;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ isLoading: isLoading, contentId: contentId, contentTab: contentTab, onClickAnalyticsLink: onClickAnalyticsLink })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eE4L.AnalyticsDialogFooterSkeleton), {
        "data-testid": (0, $cLD3i.TestId).LINK_SKELETON
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4103eac0db9bd496$export$651095642c93be3d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbb8c99c53de7179$export$b5022d69a013cca3), {
        contentId: contentId,
        contentTab: contentTab,
        testId: (0, $cLD3i.TestId).LINK,
        onClick: onClickAnalyticsLink
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f5795ebaaf370945$var$i18n.viewMoreInsightsButton))));
};
module.exports["AnalyticsDialogFooter"] = $f5795ebaaf370945$export$a856abee04b676b5;

});

parcelRegister("6eE4L", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d02b5a85e0143ead$var$Skeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_i0dl1wug _1o9zidpf _bfhkizff",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_i0dl1wug _1o9zidpf _bfhkizff",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$68161008f501db7 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18s8v77o _2rko1rr0 _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8v77o _2rko1rr0 _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$a718239236aa2e93 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _1bsb1lit _4t3idlk8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _1bsb1lit _4t3idlk8",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$d5459929e26fa4f = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _1bsbckbl _4t3idlk8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _1bsbckbl _4t3idlk8",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$fa4da77c69891775 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsb1crf _4t3i1crf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1crf _4t3i1crf",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$e9f26223e94aca50 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsbys9h _4t3i7vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsbys9h _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$16a063e498e9aae = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$173a22150dece2b5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _1bsb1ylp _4t3i1f4h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _1bsb1ylp _4t3i1f4h",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$ef91630a48099e50 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _1bsb68cl _4t3igktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _1bsb68cl _4t3igktf",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$35d4651fb1aaaf98 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _1bsb1gwv _4t3ii2wt",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _1bsb1gwv _4t3ii2wt",
            __cmplp.className
        ])
    });
});
const $d02b5a85e0143ead$export$2bdd12d32c861ea1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $d02b5a85e0143ead$var$Skeleton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsbys9h _4t3igktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $d02b5a85e0143ead$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsbys9h _4t3igktf",
            __cmplp.className
        ])
    });
});
module.exports["AvatarSkeleton"] = $d02b5a85e0143ead$export$68161008f501db7;
module.exports["PrimaryTextSkeleton"] = $d02b5a85e0143ead$export$a718239236aa2e93;
module.exports["SecondaryTextSkeleton"] = $d02b5a85e0143ead$export$d5459929e26fa4f;
module.exports["PanelHeadingSkeleton"] = $d02b5a85e0143ead$export$fa4da77c69891775;
module.exports["PanelHeadingSkeleton2"] = $d02b5a85e0143ead$export$e9f26223e94aca50;
module.exports["PanelHeadingSkeleton3"] = $d02b5a85e0143ead$export$16a063e498e9aae;
module.exports["UserProgressSkeleton"] = $d02b5a85e0143ead$export$173a22150dece2b5;
module.exports["MentionedTextSkeleton"] = $d02b5a85e0143ead$export$ef91630a48099e50;
module.exports["ProgressBarSkeleton"] = $d02b5a85e0143ead$export$35d4651fb1aaaf98;
module.exports["AnalyticsDialogFooterSkeleton"] = $d02b5a85e0143ead$export$2bdd12d32c861ea1;

});

parcelRegister("eQN4n", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $pG0Ei = parcelRequire("pG0Ei");


var $cLD3i = parcelRequire("cLD3i");











var $hekY6 = parcelRequire("hekY6");

const $17713cca3bb0a8fa$export$4d50f5d239ca819e = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1x8w1vji _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1x8w1vji _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $17713cca3bb0a8fa$export$3db34ffc2763dfdb = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});









var $2QrXF = parcelRequire("2QrXF");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");


var $gvWVt = parcelRequire("gvWVt");


var $fs6LW = parcelRequire("fs6LW");





var $auSj5 = parcelRequire("auSj5");


var $6eE4L = parcelRequire("6eE4L");


var $lllii = parcelRequire("lllii");


const $4d9958b0fdae8615$var$i18n = (0, $kSwu1.defineMessages)({
    anonymous: {
        id: "confluence-analytics.dialog.user-list.anonymous-user-name",
        defaultMessage: "Anonymous"
    },
    deactivated: {
        id: "confluence-analytics.dialog.user-list.deactivated-user-label",
        defaultMessage: "Deactivated"
    }
});
const $4d9958b0fdae8615$var$EngagementLozengeSkeletonStyles = (0, $buxP3.xcss)({
    width: '80px',
    height: '24px',
    backgroundColor: 'color.skeleton'
});
const $4d9958b0fdae8615$var$EngagementLozengeStyles = (0, $buxP3.xcss)({
    width: '120px',
    textAlign: 'right'
});
const $4d9958b0fdae8615$var$GuestAvatarStyles = (0, $buxP3.xcss)({
    width: '200px'
});
const $4d9958b0fdae8615$var$DefaultAvatarStyles = (0, $buxP3.xcss)({
    width: '260px'
});
const $4d9958b0fdae8615$var$UserContainerStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.negative.075'
});
const $4d9958b0fdae8615$export$961d633fc7d1adf5 = ({ isLoading: isLoading, account: account })=>{
    const intl = (0, $kSwu1.useIntl)();
    const displayName = (0, $cozmU.useMemo)(()=>{
        if (isLoading) return null;
        if (account.accountType === (0, $pG0Ei.AccountType).ANONYMOUS) return intl.formatMessage($4d9958b0fdae8615$var$i18n.anonymous);
        if (account.isDeactivated) return `${account.name} (${intl.formatMessage($4d9958b0fdae8615$var$i18n.deactivated)})`;
        return account.name;
    }, [
        account?.accountType,
        account?.isDeactivated,
        account?.name,
        intl,
        isLoading
    ]);
    const secondaryText = (0, $cozmU.useMemo)(()=>{
        if (isLoading) return null;
        if (!account?.lastViewedAt) return null;
        return (0, $auSj5.getLastViewedText)(new Date(account.lastViewedAt), intl);
    }, [
        account?.lastViewedAt,
        intl,
        isLoading
    ]);
    const engagementLozenge = (0, $cozmU.useMemo)(()=>{
        if (isLoading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lllii.EngagementCell), {
            isEngaged: account?.isEngaged ?? null,
            lastViewDate: account.lastViewedAt
        });
    }, [
        account?.isEngaged,
        account?.lastViewedAt,
        isLoading
    ]);
    const ariaLabel = (0, $cozmU.useMemo)(()=>{
        const ariaLabelParts = [
            displayName,
            secondaryText
        ].filter(Boolean);
        if (ariaLabelParts.length === 0) return undefined;
        return ariaLabelParts.join(', ');
    }, [
        displayName,
        secondaryText
    ]);
    const name = displayName ?? '';
    const isGuest = account?.accountType === (0, $pG0Ei.AccountType).GUEST;
    const avatarItem = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: isGuest ? $4d9958b0fdae8615$var$GuestAvatarStyles : $4d9958b0fdae8615$var$DefaultAvatarStyles,
            testId: "analytics-dialog-user-list-row-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2QrXF.default), {
            avatar: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eE4L.AvatarSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
                userId: account.id,
                src: account.avatarURL ?? '',
                isAnonymous: account.accountType === (0, $pG0Ei.AccountType).ANONYMOUS,
                canViewProfile: true,
                size: "small",
                name: name
            }),
            primaryText: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eE4L.PrimaryTextSkeleton), null) : displayName,
            secondaryText: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eE4L.SecondaryTextSkeleton), null) : secondaryText,
            isTruncationDisabled: false
        }));
    }, [
        isLoading,
        account?.id,
        account?.avatarURL,
        account?.accountType,
        name,
        secondaryText,
        isGuest,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17713cca3bb0a8fa$export$3db34ffc2763dfdb), {
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $4d9958b0fdae8615$var$UserContainerStyles
    }, avatarItem, isGuest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $4d9958b0fdae8615$var$EngagementLozengeSkeletonStyles,
        testId: "analytics-dialog-engagement-lozenge-loading"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $4d9958b0fdae8615$var$EngagementLozengeStyles
    }, engagementLozenge)));
};


const $2487d78d0be62483$var$loadingStateRowCount = 5;
const $2487d78d0be62483$export$b6537e39aa8a57e2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { isLoading: isLoading, accounts: accounts, ariaLabel: ariaLabel } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const t1 = isLoading ? "alert" : undefined;
    let t2;
    if ($[0] !== ariaLabel || $[1] !== intl || $[2] !== isLoading) {
        t2 = isLoading ? intl.formatMessage({
            id: "confluence-analytics.dialog.user-list.loading-label",
            defaultMessage: "Loading"
        }) : ariaLabel;
        $[0] = ariaLabel;
        $[1] = intl;
        $[2] = isLoading;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== accounts || $[5] !== isLoading) {
        t3 = isLoading ? Array($2487d78d0be62483$var$loadingStateRowCount).fill(null).map($2487d78d0be62483$var$_temp) : accounts.map($2487d78d0be62483$var$_temp2);
        $[4] = accounts;
        $[5] = isLoading;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== isLoading || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17713cca3bb0a8fa$export$4d50f5d239ca819e), {
            role: t1,
            "aria-busy": isLoading,
            "aria-live": "polite",
            "aria-label": t2,
            "data-testid": (0, $cLD3i.TestId).USER_LIST
        }, t3);
        $[7] = isLoading;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ isLoading: isLoading, accounts: accounts, ariaLabel: ariaLabel })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17713cca3bb0a8fa$export$4d50f5d239ca819e), {
        role: isLoading ? 'alert' : undefined,
        "aria-busy": isLoading,
        "aria-live": "polite",
        "aria-label": isLoading ? intl.formatMessage({
            id: "confluence-analytics.dialog.user-list.loading-label",
            defaultMessage: "Loading"
        }) : ariaLabel,
        "data-testid": (0, $cLD3i.TestId).USER_LIST
    }, isLoading ? Array($2487d78d0be62483$var$loadingStateRowCount).fill(null).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d9958b0fdae8615$export$961d633fc7d1adf5), {
            key: `loading-${index}`,
            isLoading: true
        })) : accounts.map((account, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d9958b0fdae8615$export$961d633fc7d1adf5), {
            key: account.accountType === (0, $pG0Ei.AccountType).ANONYMOUS ? `anonymous-${index_0}` : account.id,
            isLoading: false,
            account: account
        })));
};
function $2487d78d0be62483$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d9958b0fdae8615$export$961d633fc7d1adf5), {
        key: `loading-${index}`,
        isLoading: true
    });
}
function $2487d78d0be62483$var$_temp2(account, index_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d9958b0fdae8615$export$961d633fc7d1adf5), {
        key: account.accountType === (0, $pG0Ei.AccountType).ANONYMOUS ? `anonymous-${index_0}` : account.id,
        isLoading: false,
        account: account
    });
}
module.exports["AnalyticsDialogUserList"] = $2487d78d0be62483$export$b6537e39aa8a57e2;

});

parcelRegister("pG0Ei", function(module, exports) {
var $8787696ab5570b52$export$b8ca5fa4899cbfc7 = /*#__PURE__*/ function(AccountType) {
    AccountType["NORMAL"] = "normal";
    AccountType["GUEST"] = "guest";
    AccountType["ANONYMOUS"] = "anonymous";
    return AccountType;
}({});
module.exports["AccountType"] = $8787696ab5570b52$export$b8ca5fa4899cbfc7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("fs6LW", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $arQY7 = parcelRequire("arQY7");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $buxP3.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $buxP3.xcss)({
        display: 'flex'
    }),
    cursor: (0, $buxP3.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $kSwu1.useIntl)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $cozmU.useRef)(null);
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $cozmU.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $cozmU.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("lllii", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $aCJyI = parcelRequire("aCJyI");


var $hjyA9 = parcelRequire("hjyA9");

const $9175af89be00eded$var$i18n = (0, $kSwu1.defineMessages)({
    engagedLozengeLabel: {
        id: "confluence-analytics.engagement-cell.engaged",
        defaultMessage: "Engaged"
    },
    briefLozengeLabel: {
        id: "confluence-analytics.engagement-cell.brief",
        defaultMessage: "Brief"
    }
});
const $9175af89be00eded$var$EngagementCellStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.500'
});
const $9175af89be00eded$export$7d524b5247ca65fe = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isEngaged: isEngaged, lastViewDate: lastViewDate } = t0;
    if (!lastViewDate) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $9175af89be00eded$var$EngagementCellStyles,
                testId: "engagement-cell"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                color: "color.text.disabled"
            }, (0, $hjyA9.NO_DATA_PLACEHOLDER)));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    const t1 = isEngaged ? "information" : "warning";
    const t2 = isEngaged ? $9175af89be00eded$var$i18n.engagedLozengeLabel : $9175af89be00eded$var$i18n.briefLozengeLabel;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t2);
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t1 || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $9175af89be00eded$var$EngagementCellStyles,
            testId: "engagement-cell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aCJyI.default), {
            appearance: t1
        }, t3));
        $[3] = t1;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ isEngaged: isEngaged, lastViewDate: lastViewDate })=>{
    if (!lastViewDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $9175af89be00eded$var$EngagementCellStyles,
        testId: "engagement-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.disabled"
    }, (0, $hjyA9.NO_DATA_PLACEHOLDER)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $9175af89be00eded$var$EngagementCellStyles,
        testId: "engagement-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aCJyI.default), {
        appearance: isEngaged ? 'information' : 'warning'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isEngaged ? $9175af89be00eded$var$i18n.engagedLozengeLabel : $9175af89be00eded$var$i18n.briefLozengeLabel)));
};
module.exports["EngagementCell"] = $9175af89be00eded$export$7d524b5247ca65fe;

});

parcelRegister("hjyA9", function(module, exports) {
const $7ecc43a78c6b5753$export$752740b4377c7819 = "\u2014";
const $7ecc43a78c6b5753$export$5359594223d2611f = (sorting)=>(rowA, rowB)=>{
        if (!sorting) return 0;
        const valueA = rowA.data[sorting.field];
        const valueB = rowB.data[sorting.field];
        // Handle numerical values
        const isNumberA = typeof valueA === 'number';
        const isNumberB = typeof valueB === 'number';
        if (isNumberA && isNumberB) return sorting.direction === 'asc' ? valueA - valueB : valueB - valueA;
        // For ISO dates and other strings, fallback to string comparison
        const stringA = String(valueA).toLowerCase();
        const stringB = String(valueB).toLowerCase();
        if (stringA < stringB) return sorting.direction === 'asc' ? -1 : 1;
        if (stringA > stringB) return sorting.direction === 'asc' ? 1 : -1;
        return 0;
    };
var $7ecc43a78c6b5753$export$611eb6518a3b156e = /*#__PURE__*/ function(AnalyticsTableUIState) {
    AnalyticsTableUIState["Error"] = "Error";
    AnalyticsTableUIState["Loading"] = "Loading";
    AnalyticsTableUIState["Filtering"] = "Filtering";
    AnalyticsTableUIState["NoFilterResults"] = "NoFilterResults";
    AnalyticsTableUIState["Data"] = "Data";
    AnalyticsTableUIState["Empty"] = "Empty";
    return AnalyticsTableUIState;
}({});
const $7ecc43a78c6b5753$export$22a0f52d870655f7 = (props, table)=>{
    if (props.hasError) return "Error";
    if (props.isLoading) return "Loading";
    if (Boolean(props.isFiltering) && table.rows.length === 0) return "NoFilterResults";
    if (props.isFiltering) return "Filtering";
    if (table.rows.length === 0) return "Empty";
    return "Data";
};
module.exports["NO_DATA_PLACEHOLDER"] = $7ecc43a78c6b5753$export$752740b4377c7819;
module.exports["sortByState"] = $7ecc43a78c6b5753$export$5359594223d2611f;
module.exports["AnalyticsTableUIState"] = $7ecc43a78c6b5753$export$611eb6518a3b156e;
module.exports["getTableUIState"] = $7ecc43a78c6b5753$export$22a0f52d870655f7;

});

parcelRegister("jS7pv", function(module, exports) {
var $d3258a672d0895b9$export$f067415f668a97e9 = /*#__PURE__*/ function(TestId) {
    // CAUTION: if you update this you'll need to update the contents of the scripts in src/ssr-scripts.
    TestId["BYLINE"] = "analytics-byline";
    return TestId;
}({});
const $d3258a672d0895b9$export$f79f9d6fd24cf942 = 'analyticsByLine';
const $d3258a672d0895b9$export$5ac4ec80482fdf4b = 'clicked-analytics-byline-fmp-ssr.rendered';
module.exports["TestId"] = $d3258a672d0895b9$export$f067415f668a97e9;
module.exports["SSR_EVENTS_CAPTURE_KEY"] = $d3258a672d0895b9$export$f79f9d6fd24cf942;
module.exports["CLICKED_BYLINE_SSR_MARK"] = $d3258a672d0895b9$export$5ac4ec80482fdf4b;

});

parcelRegister("kwDQA", function(module, exports) {
/**
 * @generated SignedSource<<c4c634ffb5984138b240a2bcc61996d1>>
 * @relayHash 68505bc224ec19edfba49afd43c7d907
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99
const $377c093245c44338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "68505bc224ec19edfba49afd43c7d907",
            "id": "7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99",
            "metadata": {},
            "name": "useAnalyticsByLineQuery",
            "operationKind": "query",
            "text": "query useAnalyticsByLineQuery($contentId:ID!){contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$377c093245c44338$var$node.hash = "1059930ceaf11a1fca0cb8f2f9d20c27";
var $377c093245c44338$export$2e2bcd8739ae039 = $377c093245c44338$var$node;
module.exports["default"] = $377c093245c44338$export$2e2bcd8739ae039;

});

parcelRegister("fwH9Y", function(module, exports) {

let $b4db52ccc4e49402$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b4db52ccc4e49402$var$load("ftDGD"),
    $b4db52ccc4e49402$var$load("6wr18"),
    $b4db52ccc4e49402$var$load("49rXL"),
    $b4db52ccc4e49402$var$load("nGUH4"),
    $b4db52ccc4e49402$var$load("FJgmQ"),
    $b4db52ccc4e49402$var$load("agv3Q"),
    $b4db52ccc4e49402$var$load("8GuF9"),
    $b4db52ccc4e49402$var$load("4F5gj"),
    $b4db52ccc4e49402$var$load("7EorR"),
    $b4db52ccc4e49402$var$load("7oAXW"),
    $b4db52ccc4e49402$var$load("4fYzp"),
    $b4db52ccc4e49402$var$load("5zHCN"),
    $b4db52ccc4e49402$var$load("h1yOv"),
    $b4db52ccc4e49402$var$load("ffEVr"),
    $b4db52ccc4e49402$var$load("cHcD4"),
    $b4db52ccc4e49402$var$load("2m65P"),
    $b4db52ccc4e49402$var$load("80Yra"),
    $b4db52ccc4e49402$var$load("houtd"),
    $b4db52ccc4e49402$var$load("20Osv")
]).then(()=>parcelRequire('cPQ7p'));

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("bg9GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8328b4ddc95230a8$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8328b4ddc95230a8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInHour);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("7tXrp", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("bZEz9", function(module, exports) {
$parcel$export(module.exports, "default", () => $8bb4dbc1ad9edabe$export$2e2bcd8739ae039);

var $68pA8 = parcelRequire("68pA8");


var $gkHoc = parcelRequire("gkHoc");


var $58FyF = parcelRequire("58FyF");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $8bb4dbc1ad9edabe$export$2e2bcd8739ae039(dirtyDate, duration) {
    (0, $3yGK6.default)(2, arguments);
    if (!duration || (0, $68pA8.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, $kr6hK.default)(duration.years) : 0;
    var months = duration.months ? (0, $kr6hK.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $kr6hK.default)(duration.weeks) : 0;
    var days = duration.days ? (0, $kr6hK.default)(duration.days) : 0;
    var hours = duration.hours ? (0, $kr6hK.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $kr6hK.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $kr6hK.default)(duration.seconds) : 0;
    // Add years and months
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateWithMonths = months || years ? (0, $58FyF.default)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, $gkHoc.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});

parcelRegister("58FyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bddefb3ed7cf5f3$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $3bddefb3ed7cf5f3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("fNtG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8027429ed7dcbe2$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $b8027429ed7dcbe2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInMinute);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hnDzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca7347c324945db7$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $9wdry = parcelRequire("9wdry");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");

function $ca7347c324945db7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $9wdry.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("9wdry", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee187ccd32d3646$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $6ee187ccd32d3646$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("hqoIw", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf809a9e58fcf65$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $caf809a9e58fcf65$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("1xxT0", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f3289e9f8e4176$export$2e2bcd8739ae039);

var $gkHoc = parcelRequire("gkHoc");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $11f3289e9f8e4176$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $gkHoc.default)(dirtyDate, -amount);
}

});

parcelRegister("d5Gk5", function(module, exports) {
$parcel$export(module.exports, "default", () => $987c9279ed677b25$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $58FyF = parcelRequire("58FyF");


var $3yGK6 = parcelRequire("3yGK6");

function $987c9279ed677b25$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $58FyF.default)(dirtyDate, -amount);
}

});

parcelRegister("cXNn3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jp2Q3 = parcelRequire("jp2Q3");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");


var $9eE57 = parcelRequire("9eE57");


var $7aRa9 = parcelRequire("7aRa9");


var $luv00 = parcelRequire("luv00");


var $e4o8D = parcelRequire("e4o8D");


var $5Abqh = parcelRequire("5Abqh");


var $lsxnT = parcelRequire("lsxnT");


var $aXes4 = parcelRequire("aXes4");















const $c8111d736b2f6a35$export$3526fb65ade8d8b7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { ssrEventCaptureKey: ssrEventCaptureKey, name: name } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [triggeredSSRCapturedEvents, setTriggeredSSRCapturedEvents] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] !== triggeredSSRCapturedEvents) {
        t2 = (event)=>!!triggeredSSRCapturedEvents[event];
        $[1] = triggeredSSRCapturedEvents;
        $[2] = t2;
    } else t2 = $[2];
    const wasSSREventTriggered = t2;
    const updateSSRCapturedEvent = $c8111d736b2f6a35$var$_temp;
    let t3;
    if ($[3] !== ssrEventCaptureKey) {
        t3 = (event_1)=>!!window?.__SSR_EVENTS_CAPTURE__?.[ssrEventCaptureKey]?.[event_1];
        $[3] = ssrEventCaptureKey;
        $[4] = t3;
    } else t3 = $[4];
    const wasSSREventCaptured = t3;
    let t4;
    if ($[5] !== wasSSREventCaptured || $[6] !== wasSSREventTriggered) {
        t4 = (event_2, callback)=>{
            if (wasSSREventTriggered(event_2)) return;
            if (wasSSREventCaptured(event_2)) {
                callback();
                const updatedEvent = updateSSRCapturedEvent(event_2);
                setTriggeredSSRCapturedEvents((triggeredSSRCapturedEvents_0)=>({
                        ...triggeredSSRCapturedEvents_0,
                        ...updatedEvent
                    }));
            }
        };
        $[5] = wasSSREventCaptured;
        $[6] = wasSSREventTriggered;
        $[7] = t4;
    } else t4 = $[7];
    const onSSRCapturedEvent = t4;
    let t5;
    if ($[8] !== name) {
        t5 = (0, $5Abqh.checkSSRPartialSuccess)(name);
        $[8] = name;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== onSSRCapturedEvent || $[11] !== t5 || $[12] !== wasSSREventTriggered) {
        t6 = {
            onSSRCapturedEvent: onSSRCapturedEvent,
            wasSSREventTriggered: wasSSREventTriggered,
            wasComponentSSRed: t5
        };
        $[10] = onSSRCapturedEvent;
        $[11] = t5;
        $[12] = wasSSREventTriggered;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ ssrEventCaptureKey: ssrEventCaptureKey, name: name })=>{
    const [triggeredSSRCapturedEvents, setTriggeredSSRCapturedEvents] = (0, $cozmU.useState)({});
    const wasSSREventTriggered = (0, $cozmU.useCallback)((event)=>{
        return !!triggeredSSRCapturedEvents[event];
    }, [
        triggeredSSRCapturedEvents
    ]);
    const updateSSRCapturedEvent = (event_0)=>{
        switch(event_0){
            case (0, $aXes4.SSREvent).CLICK:
                return {
                    click: true
                };
            case (0, $aXes4.SSREvent).FOCUS:
                return {
                    focus: true
                };
            case (0, $aXes4.SSREvent).HOVER:
                return {
                    hover: true
                };
        }
    };
    const wasSSREventCaptured = (0, $cozmU.useCallback)((event_1)=>{
        return !!window?.__SSR_EVENTS_CAPTURE__?.[ssrEventCaptureKey]?.[event_1];
    }, [
        ssrEventCaptureKey
    ]);
    const onSSRCapturedEvent = (0, $cozmU.useCallback)((event_2, callback)=>{
        if (wasSSREventTriggered(event_2)) return;
        if (wasSSREventCaptured(event_2)) {
            callback();
            const updatedEvent = updateSSRCapturedEvent(event_2);
            setTriggeredSSRCapturedEvents((triggeredSSRCapturedEvents_0)=>({
                    ...triggeredSSRCapturedEvents_0,
                    ...updatedEvent
                }));
        }
    }, [
        wasSSREventCaptured,
        wasSSREventTriggered
    ]);
    return {
        onSSRCapturedEvent: onSSRCapturedEvent,
        wasSSREventTriggered: wasSSREventTriggered,
        wasComponentSSRed: (0, $5Abqh.checkSSRPartialSuccess)(name)
    };
};
function $c8111d736b2f6a35$var$_temp(event_0) {
    switch(event_0){
        case (0, $aXes4.SSREvent).CLICK:
            return {
                click: true
            };
        case (0, $aXes4.SSREvent).FOCUS:
            return {
                focus: true
            };
        case (0, $aXes4.SSREvent).HOVER:
            return {
                hover: true
            };
    }
}



var $jHois = parcelRequire("jHois");











var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $bQm3c = parcelRequire("bQm3c");


var $cLD3i = parcelRequire("cLD3i");


var $jrT4o = parcelRequire("jrT4o");














var $I7hWB = parcelRequire("I7hWB");


var $l3wuH = parcelRequire("l3wuH");


var $b1FLc = parcelRequire("b1FLc");


var $kz1Yj = parcelRequire("kz1Yj");





var $gtMdU = parcelRequire("gtMdU");








var $1l0kj = parcelRequire("1l0kj");













var $kh0hi = parcelRequire("kh0hi");



const $9239993598be6be2$var$selectedPillButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $9239993598be6be2$var$unselectedPillButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral',
    color: 'color.text',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $9239993598be6be2$var$pillButtonStyles = (0, $buxP3.xcss)({
    outline: 'none',
    paddingBlock: 'space.050',
    paddingInline: 'space.200',
    display: 'inline-flex',
    border: 'none',
    borderRadius: 'radius.full',
    font: 'font.body',
    height: '28px',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    verticalAlign: 'top'
});
const $9239993598be6be2$export$c5e39530e713771e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let buttonProps;
    let isSelected;
    if ($[0] !== props) {
        ({ isSelected: isSelected, ...buttonProps } = props);
        $[0] = props;
        $[1] = buttonProps;
        $[2] = isSelected;
    } else {
        buttonProps = $[1];
        isSelected = $[2];
    }
    const t0 = isSelected ? $9239993598be6be2$var$selectedPillButtonStyles : $9239993598be6be2$var$unselectedPillButtonStyles;
    let t1;
    if ($[3] !== t0) {
        t1 = [
            $9239993598be6be2$var$pillButtonStyles,
            t0
        ];
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== buttonProps || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            ...buttonProps,
            xcss: t1
        });
        $[5] = buttonProps;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>{
    const { isSelected: isSelected, ...buttonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        ...buttonProps,
        xcss: [
            $9239993598be6be2$var$pillButtonStyles,
            isSelected ? $9239993598be6be2$var$selectedPillButtonStyles : $9239993598be6be2$var$unselectedPillButtonStyles
        ]
    });
};
const $9239993598be6be2$var$skeletonPillRowStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $9239993598be6be2$export$46acda2e6517933 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ...props,
            xcss: $9239993598be6be2$var$skeletonPillRowStyles
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ...props,
        xcss: $9239993598be6be2$var$skeletonPillRowStyles
    });
};
const $9239993598be6be2$var$skeletonPillStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.full'
});
const $9239993598be6be2$export$b8de7e3369d2dd6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let divProps;
    let height;
    let width;
    if ($[0] !== props) {
        ({ width: width, height: height, ...divProps } = props);
        $[0] = props;
        $[1] = divProps;
        $[2] = height;
        $[3] = width;
    } else {
        divProps = $[1];
        height = $[2];
        width = $[3];
    }
    const t0 = `${width ?? 95}px`;
    const t1 = `${height ?? 28}px`;
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = {
            width: t0,
            height: t1
        };
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== divProps || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ...divProps,
            xcss: $9239993598be6be2$var$skeletonPillStyles,
            style: t2
        });
        $[7] = divProps;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : (props)=>{
    const { width: width, height: height, ...divProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ...divProps,
        xcss: $9239993598be6be2$var$skeletonPillStyles,
        style: {
            width: `${width ?? 95}px`,
            height: `${height ?? 28}px`
        }
    });
};


const $14e8d87431cca51e$var$skeletonPillHeight = 28;
const $14e8d87431cca51e$export$5dfbe097b84ae180 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { selectedPill: selectedPill, pills: pills, isLoading: isLoading, onPillSelected: onPillSelected, fireAnalyticsEvent: fireAnalyticsEvent, testId: testId } = t0;
    let t1;
    if ($[0] !== fireAnalyticsEvent || $[1] !== onPillSelected) {
        t1 = (pillName)=>{
            onPillSelected(pillName);
            fireAnalyticsEvent?.(pillName);
        };
        $[0] = fireAnalyticsEvent;
        $[1] = onPillSelected;
        $[2] = t1;
    } else t1 = $[2];
    const onPillSelectedInternal = t1;
    if (isLoading) {
        let t2;
        if ($[3] !== pills) {
            t2 = pills.map($14e8d87431cca51e$var$_temp);
            $[3] = pills;
            $[4] = t2;
        } else t2 = $[4];
        const skeletonPills = t2;
        const t3 = `${testId}-skeleton`;
        let t4;
        if ($[5] !== skeletonPills || $[6] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                space: "space.100",
                testId: t3
            }, skeletonPills);
            $[5] = skeletonPills;
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    let t2;
    if ($[8] !== onPillSelectedInternal || $[9] !== pills || $[10] !== selectedPill) {
        let t3;
        if ($[12] !== onPillSelectedInternal || $[13] !== selectedPill) {
            t3 = (pill_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9239993598be6be2$export$c5e39530e713771e, {
                    id: pill_0.name,
                    key: pill_0.name,
                    isSelected: pill_0.name === selectedPill,
                    onClick: ()=>onPillSelectedInternal(pill_0.name),
                    role: "tab",
                    "aria-controls": pill_0.name,
                    "aria-selected": pill_0.name === selectedPill,
                    testId: pill_0.name
                }, pill_0.content);
            $[12] = onPillSelectedInternal;
            $[13] = selectedPill;
            $[14] = t3;
        } else t3 = $[14];
        t2 = pills.map(t3);
        $[8] = onPillSelectedInternal;
        $[9] = pills;
        $[10] = selectedPill;
        $[11] = t2;
    } else t2 = $[11];
    const pillButtons = t2;
    let t3;
    if ($[15] !== pillButtons || $[16] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            role: "tablist",
            testId: testId
        }, pillButtons);
        $[15] = pillButtons;
        $[16] = testId;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
} : ({ selectedPill: selectedPill, pills: pills, isLoading: isLoading, onPillSelected: onPillSelected, fireAnalyticsEvent: fireAnalyticsEvent, testId: testId })=>{
    const onPillSelectedInternal = (0, $cozmU.useCallback)((pillName)=>{
        onPillSelected(pillName);
        fireAnalyticsEvent?.(pillName);
    }, [
        onPillSelected,
        fireAnalyticsEvent
    ]);
    if (isLoading) {
        const skeletonPills = pills.map((pill)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9239993598be6be2$export$b8de7e3369d2dd6b, {
                key: pill.name,
                width: pill.skeletonWidth,
                height: $14e8d87431cca51e$var$skeletonPillHeight
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            testId: `${testId}-skeleton`
        }, skeletonPills);
    }
    const pillButtons = pills.map((pill_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9239993598be6be2$export$c5e39530e713771e, {
            id: pill_0.name,
            key: pill_0.name,
            isSelected: pill_0.name === selectedPill,
            onClick: ()=>onPillSelectedInternal(pill_0.name),
            role: "tab",
            "aria-controls": pill_0.name,
            "aria-selected": pill_0.name === selectedPill,
            testId: pill_0.name
        }, pill_0.content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        role: "tablist",
        testId: testId
    }, pillButtons);
};
function $14e8d87431cca51e$var$_temp(pill) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9239993598be6be2$export$b8de7e3369d2dd6b, {
        key: pill.name,
        width: pill.skeletonWidth,
        height: $14e8d87431cca51e$var$skeletonPillHeight
    });
}






var $euL71 = parcelRequire("euL71");














var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");

const $382f6858a3ae1da3$export$8b251419efc915eb = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $382f6858a3ae1da3$export$de65de8213222d10 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $7ZB0A.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf",
            __cmplp.className
        ])
    });
});


const $1af0445059f14528$var$i18n = (0, $kSwu1.defineMessages)({
    dialogHeader: {
        id: "confluence-analytics.dialog.header",
        defaultMessage: "Analytics"
    },
    dialogCloseAriaLabel: {
        id: "confluence-analytics.dialog.close-aria-label",
        defaultMessage: "Close Confluence Analytics nonmodal dialog"
    },
    dialogCloseLabel: {
        id: "confluence-analytics.dialog.close-label",
        defaultMessage: "Close modal"
    },
    filterViewed: {
        id: "confluence-analytics.filters.views",
        defaultMessage: "Views"
    },
    filterMentioned: {
        id: "confluence-analytics.filters.mentions",
        defaultMessage: "Mentions"
    },
    filterLinks: {
        id: "confluence-analytics.filters.links",
        defaultMessage: "Links"
    }
});
const $1af0445059f14528$var$PillSelectorContainerStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $1af0445059f14528$export$9e87abbac09c85ce = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { error: error, isLoading: isLoading, selectedPill: selectedPill, isPrivacyModeEnabled: isPrivacyModeEnabled, onPillSelected: t1, onClose: onClose } = t0;
    const onPillSelected = t1 === undefined ? $1af0445059f14528$var$_temp : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldShowLoadingState = isLoading || !!error;
    let t2;
    if ($[0] !== intl) {
        t2 = intl.formatMessage($1af0445059f14528$var$i18n.dialogCloseLabel);
        $[0] = intl;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            spacing: "spacious",
            label: t2,
            color: "var(--ds-icon, #292A2E)"
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== onClose || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1FLc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($382f6858a3ae1da3$export$de65de8213222d10, {
            appearance: "link",
            onClick: onClose,
            testId: (0, $cLD3i.TestId).CLOSE_BUTTON
        }, t3));
        $[4] = onClose;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const closeButton = t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            name: (0, $cLD3i.DialogPillName).VIEWS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.filterViewed)
        };
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== edition || $[9] !== isPrivacyModeEnabled) {
        t6 = [
            t5,
            ...edition === (0, $euL71.ConfluenceEdition).PREMIUM ? [
                ...!isPrivacyModeEnabled ? [
                    {
                        name: (0, $cLD3i.DialogPillName).MENTIONS,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.filterMentioned)
                    }
                ] : [],
                {
                    name: (0, $cLD3i.DialogPillName).LINKS,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.filterLinks)
                }
            ] : []
        ];
        $[8] = edition;
        $[9] = isPrivacyModeEnabled;
        $[10] = t6;
    } else t6 = $[10];
    const dialogPills = t6;
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.dialogHeader));
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== closeButton) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            spread: "space-between"
        }, t7, closeButton);
        $[12] = closeButton;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== dialogPills || $[15] !== onPillSelected || $[16] !== selectedPill || $[17] !== shouldShowLoadingState) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $1af0445059f14528$var$PillSelectorContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14e8d87431cca51e$export$5dfbe097b84ae180), {
            isLoading: shouldShowLoadingState,
            pills: dialogPills,
            selectedPill: selectedPill,
            testId: (0, $cLD3i.TestId).PILLS,
            onPillSelected: onPillSelected
        }));
        $[14] = dialogPills;
        $[15] = onPillSelected;
        $[16] = selectedPill;
        $[17] = shouldShowLoadingState;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== t8 || $[20] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9);
        $[19] = t8;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
} : ({ error: error, isLoading: isLoading, selectedPill: selectedPill, isPrivacyModeEnabled: isPrivacyModeEnabled, onPillSelected: onPillSelected = ()=>{}, onClose: onClose })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldShowLoadingState = (0, $cozmU.useMemo)(()=>isLoading || !!error, [
        isLoading,
        error
    ]);
    const closeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1FLc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($382f6858a3ae1da3$export$de65de8213222d10, {
        appearance: "link",
        onClick: onClose,
        testId: (0, $cLD3i.TestId).CLOSE_BUTTON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        spacing: "spacious",
        label: intl.formatMessage($1af0445059f14528$var$i18n.dialogCloseLabel),
        color: "var(--ds-icon, #292A2E)"
    })));
    const dialogPills = [
        {
            name: (0, $cLD3i.DialogPillName).VIEWS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.filterViewed)
        },
        ...edition === (0, $euL71.ConfluenceEdition).PREMIUM ? [
            ...!isPrivacyModeEnabled ? [
                {
                    name: (0, $cLD3i.DialogPillName).MENTIONS,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.filterMentioned)
                }
            ] : [],
            {
                name: (0, $cLD3i.DialogPillName).LINKS,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.filterLinks)
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1af0445059f14528$var$i18n.dialogHeader)), closeButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $1af0445059f14528$var$PillSelectorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14e8d87431cca51e$export$5dfbe097b84ae180), {
        isLoading: shouldShowLoadingState,
        pills: dialogPills,
        selectedPill: selectedPill,
        testId: (0, $cLD3i.TestId).PILLS,
        onPillSelected: onPillSelected
    })));
};
function $1af0445059f14528$var$_temp() {}



var $c98X8 = parcelRequire("c98X8");


var $6rmEX = parcelRequire("6rmEX");


var $eQN4n = parcelRequire("eQN4n");

const $7b2bb0d910e43743$var$marginBottomStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.200'
});
const $7b2bb0d910e43743$export$9bacd85795ebefc9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { zIndex: zIndex } = t0;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldShowMentions = edition === "PREMIUM";
    let t1;
    if ($[0] !== shouldShowMentions) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1af0445059f14528$export$9e87abbac09c85ce), {
            isLoading: true,
            shouldShowPills: shouldShowMentions,
            selectedPill: (0, $cLD3i.DialogPillName).VIEWS
        });
        $[0] = shouldShowMentions;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c98X8.AnalyticsDialogInfoPanel), {
            isLoading: true,
            viewsCount: 0,
            uniqueViewsCount: 0
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $7b2bb0d910e43743$var$marginBottomStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.SSRChartSkeleton, null));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.SSRLoadingText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cLD3i.pillToLoadingTextI18n)[(0, $cLD3i.DialogPillName).VIEWS]));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== shouldShowMentions) {
        t5 = shouldShowMentions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $7b2bb0d910e43743$var$marginBottomStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQN4n.AnalyticsDialogUserList), {
            accounts: [],
            isLoading: true
        }));
        $[5] = shouldShowMentions;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6rmEX.AnalyticsDialogFooter), {
            isLoading: true,
            contentId: ""
        });
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t1 || $[9] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.Container, {
            role: "dialog"
        }, t1, t2, t3, t4, t5, t6);
        $[8] = t1;
        $[9] = t5;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t7 || $[12] !== zIndex) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.SSRContainer, {
            zIndex: zIndex,
            "data-testid": (0, $cLD3i.TestId).DIALOG_SKELETON
        }, t7);
        $[11] = t7;
        $[12] = zIndex;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ zIndex: zIndex })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldShowMentions = edition === 'PREMIUM';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.SSRContainer, {
        zIndex: zIndex,
        "data-testid": (0, $cLD3i.TestId).DIALOG_SKELETON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.Container, {
        role: "dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1af0445059f14528$export$9e87abbac09c85ce), {
        isLoading: true,
        shouldShowPills: shouldShowMentions,
        selectedPill: (0, $cLD3i.DialogPillName).VIEWS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c98X8.AnalyticsDialogInfoPanel), {
        isLoading: true,
        viewsCount: 0,
        uniqueViewsCount: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $7b2bb0d910e43743$var$marginBottomStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.SSRChartSkeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($jrT4o.SSRLoadingText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cLD3i.pillToLoadingTextI18n)[(0, $cLD3i.DialogPillName).VIEWS])), shouldShowMentions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $7b2bb0d910e43743$var$marginBottomStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQN4n.AnalyticsDialogUserList), {
        accounts: [],
        isLoading: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6rmEX.AnalyticsDialogFooter), {
        isLoading: true,
        contentId: ""
    })));
};



var $auSj5 = parcelRequire("auSj5");


var $jS7pv = parcelRequire("jS7pv");











var $6mKj3 = parcelRequire("6mKj3");




/**
 * @generated SignedSource<<a60d2c31d7a870e67db26dd12bf98584>>
 * @relayHash 5139de600d5e4e49615c1742fae27659
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf06d566e2dc098c2d1b04753fbbaf4518876e1c9388b9f50bc5e9633929f813
const $2f45bd72a0706448$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "input"
                }
            ],
            "concreteType": "NotificationResponsePayload",
            "kind": "LinkedField",
            "name": "notifyUsersOnFirstView",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineNotifyUsersOnFirstViewMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineNotifyUsersOnFirstViewMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5139de600d5e4e49615c1742fae27659",
            "id": "bf06d566e2dc098c2d1b04753fbbaf4518876e1c9388b9f50bc5e9633929f813",
            "metadata": {},
            "name": "useAnalyticsByLineNotifyUsersOnFirstViewMutation",
            "operationKind": "mutation",
            "text": "mutation useAnalyticsByLineNotifyUsersOnFirstViewMutation($input:ID!){notifyUsersOnFirstView(contentId:$input){success,errors{message}}}"
        }
    };
}();
$2f45bd72a0706448$var$node.hash = "68415d9fbcae3b85bb99318f819f12d6";
var $2f45bd72a0706448$export$2e2bcd8739ae039 = $2f45bd72a0706448$var$node;



var $kwDQA = parcelRequire("kwDQA");














var $irVI7 = parcelRequire("irVI7");


var $jMyy4 = parcelRequire("jMyy4");











var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

















var $1TvTa = parcelRequire("1TvTa");


var $lpNn5 = parcelRequire("lpNn5");



















const $13cb67b7495370c1$var$badgeStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.050',
    color: 'color.text.subtle',
    font: 'font.body.small',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.small',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    height: '24px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $13cb67b7495370c1$export$f2bb8dd0d057d45f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { message: message, onClick: onClick, iconLabel: iconLabel } = t0;
    let t1;
    if ($[0] !== iconLabel) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
            label: iconLabel
        });
        $[0] = iconLabel;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== message || $[3] !== onClick || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            onClick: onClick,
            xcss: $13cb67b7495370c1$var$badgeStyles,
            testId: "badge-style-analytics-byline"
        }, t1, message);
        $[2] = message;
        $[3] = onClick;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ message: message, onClick: onClick, iconLabel: iconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        onClick: onClick,
        xcss: $13cb67b7495370c1$var$badgeStyles,
        testId: "badge-style-analytics-byline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
        label: iconLabel
    }), message);


/* AnalyticsByLineStyled.tsx generated by @compiled/babel-plugin v0.36.1 */ 





'use no memo';
const $b0baa4af837ad18e$var$analyticsIconWrapperStyles = null;
const $b0baa4af837ad18e$export$6496ee3295d1e866 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_2hwx1b66 _s7n4nkob"
        ])
    });
const $b0baa4af837ad18e$var$analyticsBylineWrapperStyles = null;
const $b0baa4af837ad18e$var$isBylineComponentStyles = null;
const $b0baa4af837ad18e$export$b2de912be31ac4f3 = (props)=>{
    const { isBylineComponent: isBylineComponent, abbreviatePageViews: abbreviatePageViews, children: children, useBadgeStyle: useBadgeStyle, ...spanProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...spanProps,
        className: (0, $hekY6.default)([
            !useBadgeStyle && "_1e0c1o8l _syazazsu _k48pi7a9 _2hwxu2gc _19bv1b66 _1a3b1r31 _4fpr8stv _5goinqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _8kwo1r31 _1vwxglyw _2gcsnqa1 _d0altlke",
            isBylineComponent && !abbreviatePageViews && "_tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06azsu _p7f0u2gc"
        ])
    }, children);
};


const $da063c148ceb2f37$var$i18n = (0, $kSwu1.defineMessages)({
    viewers: {
        id: "confluence-analytics.byline.user-views.message",
        defaultMessage: "{count, plural, =0 {Analytics} one {1 person viewed} other {{count} people viewed}}"
    },
    abbreviatedViewers: {
        id: "confluence-analytics.byline.abbreviated-user-views.message",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{count}"
    },
    pageViewers: {
        id: "confluence-analytics.byline.page-viewers.message",
        defaultMessage: "Views"
    }
});
// The tooltip needs to be added for abbreviated page views since the text only shows the number of viewers without describing what the number is
const $da063c148ceb2f37$var$TooltipContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { abbreviatePageViews: abbreviatePageViews, children: children } = t0;
    if (abbreviatePageViews) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $da063c148ceb2f37$var$i18n.pageViewers);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== children) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: t1,
                hideTooltipOnClick: true
            }, children);
            $[1] = children;
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    let t1;
    if ($[3] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ abbreviatePageViews: abbreviatePageViews, children: children })=>{
    if (abbreviatePageViews) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $da063c148ceb2f37$var$i18n.pageViewers),
        hideTooltipOnClick: true
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $da063c148ceb2f37$var$handleOnClick = (onClick)=>(e)=>{
        if (onClick) return onClick(e);
        return undefined;
    };
const $da063c148ceb2f37$var$formatAbbreviatedNumber = (locale, count)=>{
    try {
        const numberFormatter = Intl.NumberFormat(locale, {
            notation: 'compact',
            compactDisplay: 'short'
        });
        return numberFormatter.format(count).toLocaleLowerCase();
    } catch (e) {
        return String(count);
    }
};
const $da063c148ceb2f37$export$6875440beea453b6 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { isBylineComponent: isBylineComponent, onClick: onClick, href: href, count: count, testId: testId, abbreviatePageViews: abbreviatePageViews, useBadgeStyle: useBadgeStyle } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== count || $[1] !== intl.locale) {
        t1 = $da063c148ceb2f37$var$formatAbbreviatedNumber(intl.locale, count);
        $[0] = count;
        $[1] = intl.locale;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== abbreviatePageViews || $[4] !== intl) {
        t2 = abbreviatePageViews ? intl.formatMessage($da063c148ceb2f37$var$i18n.pageViewers) : "";
        $[3] = abbreviatePageViews;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    const analyticsIconLabel = t2;
    const t3 = abbreviatePageViews ? $da063c148ceb2f37$var$i18n.abbreviatedViewers : $da063c148ceb2f37$var$i18n.viewers;
    let t4;
    if ($[6] !== value) {
        t4 = {
            count: value
        };
        $[6] = value;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...t3,
            values: t4
        });
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    const analyticsBylineMessage = t5;
    let t6;
    if ($[11] !== analyticsBylineMessage || $[12] !== analyticsIconLabel || $[13] !== href || $[14] !== onClick || $[15] !== useBadgeStyle) {
        t6 = !useBadgeStyle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            href: href,
            onClick: $da063c148ceb2f37$var$handleOnClick(onClick),
            appearance: "subtle-link",
            spacing: "none",
            style: {
                fontWeight: "unset"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0baa4af837ad18e$export$6496ee3295d1e866, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
            label: analyticsIconLabel,
            color: "currentColor"
        })), analyticsBylineMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13cb67b7495370c1$export$f2bb8dd0d057d45f), {
            iconLabel: analyticsIconLabel,
            message: analyticsBylineMessage,
            onClick: $da063c148ceb2f37$var$handleOnClick(onClick)
        });
        $[11] = analyticsBylineMessage;
        $[12] = analyticsIconLabel;
        $[13] = href;
        $[14] = onClick;
        $[15] = useBadgeStyle;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== abbreviatePageViews || $[18] !== isBylineComponent || $[19] !== t6 || $[20] !== testId || $[21] !== useBadgeStyle) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0baa4af837ad18e$export$b2de912be31ac4f3, {
            isBylineComponent: isBylineComponent,
            abbreviatePageViews: abbreviatePageViews,
            "data-testid": testId,
            useBadgeStyle: useBadgeStyle
        }, t6);
        $[17] = abbreviatePageViews;
        $[18] = isBylineComponent;
        $[19] = t6;
        $[20] = testId;
        $[21] = useBadgeStyle;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== abbreviatePageViews || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da063c148ceb2f37$var$TooltipContainer, {
            abbreviatePageViews: abbreviatePageViews
        }, t7);
        $[23] = abbreviatePageViews;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ({ isBylineComponent: isBylineComponent, onClick: onClick, href: href, count: count, testId: testId, abbreviatePageViews: abbreviatePageViews, useBadgeStyle: useBadgeStyle })=>{
    const intl = (0, $kSwu1.useIntl)();
    const value = $da063c148ceb2f37$var$formatAbbreviatedNumber(intl.locale, count);
    const analyticsIconLabel = abbreviatePageViews ? intl.formatMessage($da063c148ceb2f37$var$i18n.pageViewers) : '';
    const analyticsBylineMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...abbreviatePageViews ? $da063c148ceb2f37$var$i18n.abbreviatedViewers : $da063c148ceb2f37$var$i18n.viewers,
        values: {
            count: value
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da063c148ceb2f37$var$TooltipContainer, {
        abbreviatePageViews: abbreviatePageViews
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0baa4af837ad18e$export$b2de912be31ac4f3, {
        isBylineComponent: isBylineComponent,
        abbreviatePageViews: abbreviatePageViews,
        "data-testid": testId,
        useBadgeStyle: useBadgeStyle
    }, !useBadgeStyle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        href: href,
        onClick: $da063c148ceb2f37$var$handleOnClick(onClick),
        appearance: "subtle-link",
        spacing: "none",
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // leaving as-is for now, as this is a temporary solution -- ENGHEALTH-24908/CCECO-4418
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        style: {
            fontWeight: 'unset'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0baa4af837ad18e$export$6496ee3295d1e866, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
        label: analyticsIconLabel,
        color: "currentColor"
    })), analyticsBylineMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13cb67b7495370c1$export$f2bb8dd0d057d45f), {
        iconLabel: analyticsIconLabel,
        message: analyticsBylineMessage,
        onClick: $da063c148ceb2f37$var$handleOnClick(onClick)
    })));
};







const $3f76c3013ece7b8d$export$1552b9c1f35032f8 = (loading, data, error)=>{
    return loading || (0, $auSj5.isSSRError)(data, error) || (0, $auSj5.isPermissionError)(error) || !(0, $auSj5.isInternalUser)(data);
};





// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $375484631ebaa373$export$86e005d79476c9b0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "RjR3u",
    name: "LazyAnalyticsDialog",
    loader: async ()=>(await (parcelRequire("fwH9Y"))).AnalyticsDialog
});












var $308Wd = parcelRequire("308Wd");

const $c206d56742b29207$var$useAnalyticsByLineQuery = (0, $kwDQA.default);
const $c206d56742b29207$export$dee95a34dad96df6 = ({ contentId: contentId, skip: skip, wasComponentSSRed: wasComponentSSRed, contentAuthorId: contentAuthorId })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [selectedPill, onPillSelected] = (0, $cozmU.useState)((0, $cLD3i.DialogPillName).VIEWS);
    const [dialogReferenceDate, setDialogReferenceDate] = (0, $cozmU.useState)(new Date());
    const [shouldRefetch, setShouldRefetch] = (0, $cozmU.useState)(false);
    const triggerRefetch = (0, $cozmU.useCallback)(()=>{
        setShouldRefetch(true);
    }, [
        setShouldRefetch
    ]);
    (0, $cozmU.useEffect)(()=>{
        setDialogReferenceDate(new Date());
        setShouldRefetch(false);
        onPillSelected((0, $cLD3i.DialogPillName).VIEWS);
    }, [
        contentId,
        // Preserved for compatibility with the AnalyticsByLine implementation
        // before this source code was moved from there to here:
        wasComponentSSRed
    ]);
    const { edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($c206d56742b29207$var$useAnalyticsByLineQuery, {
        variables: {
            contentId: contentId
        },
        context: {
            single: true
        },
        skip: skip,
        __callerPackage__: "confluence-analytics"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // mutations sends request to BE to notify users of content first view
    // content owner will receive notification on first view in bell icon
    const [notifyUsersOnFirstView, { error: notifyUsersOnFirstViewError }] = (0, $308Wd.useMutationInterop)((0, $2f45bd72a0706448$export$2e2bcd8739ae039), {
        __callerPackage__: "confluence-analytics"
    });
    const notifyUsersOnFirstViewMutationStorageKey = (0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${contentId}/${(0, $1UApO.keys).NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED}` : `${(0, $1UApO.keys).NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED}/content/${contentId}`;
    const handleNotify = (0, $cozmU.useCallback)(async ()=>{
        experienceTracker.start({
            name: (0, $irVI7.NOTIFY_ON_FIRST_VIEW_EXPERIENCE)
        });
        try {
            await notifyUsersOnFirstView({
                variables: {
                    input: contentId
                }
            });
            experienceTracker.succeed({
                name: (0, $irVI7.NOTIFY_ON_FIRST_VIEW_EXPERIENCE)
            });
            (0, $17wUi.confluenceSessionStorageInstance).setItem(notifyUsersOnFirstViewMutationStorageKey, true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'FirstViewNotification',
                    source: 'viewPageScreen',
                    objectId: contentId,
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
        } catch (err) {
            // handle error
            experienceTracker.fail({
                error: err || new Error('An unknown error has occurred'),
                name: (0, $irVI7.NOTIFY_ON_FIRST_VIEW_EXPERIENCE)
            });
        }
    }, [
        contentId,
        createAnalyticsEvent,
        experienceTracker,
        notifyUsersOnFirstView,
        notifyUsersOnFirstViewMutationStorageKey
    ]);
    // We want to allow the data to refresh once upon opening the dialog for the first time, but never
    // beyond that. This one-time refresh exists so that the data displayed in the dialog matches the
    // data being displayed in the byline.
    const hasRefetched = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (shouldRefetch && !hasRefetched.current) {
            refetch({
                contentId: contentId
            });
            hasRefetched.current = true;
        } else if (!shouldRefetch && hasRefetched.current) hasRefetched.current = false;
    }, [
        contentId,
        refetch,
        shouldRefetch
    ]);
    const count = (0, $auSj5.getViewersCount)(data);
    const hideAnalyticsByLine = (0, $3f76c3013ece7b8d$export$1552b9c1f35032f8)(loading, data, error) || count < 2;
    const isPageAuthor = userId === contentAuthorId;
    // Trigger notification if 1 page view, paid editions, english locale, & experiment enabled
    (0, $cozmU.useEffect)(()=>{
        if (count === 1 && // when user publish page without hard-reload page, the page viewer count doesn't get updated
        // adding this check to avoid duplicate calls made to complement `count === 1` check to avoid unnecessary duplicate calls in `handleNotify`
        !(0, $17wUi.confluenceSessionStorageInstance).doesContain(notifyUsersOnFirstViewMutationStorageKey) && edition !== (0, $euL71.ConfluenceEdition).FREE && !isPageAuthor && (0, $9wGTI.fg)('cc_onboarding_first_view_notify_prod')) handleNotify();
    }, [
        count,
        handleNotify,
        edition,
        isPageAuthor,
        notifyUsersOnFirstViewMutationStorageKey
    ]);
    const onPopupTriggerSSREvent = (0, $cozmU.useCallback)((event)=>{
        switch(event){
            case (0, $aXes4.SSREvent).CLICK:
                (0, $jHois.CONTENT_ANALYTICS_DIALOG_METRIC).start({
                    startTime: (0, $9eE57.getMark)((0, $jS7pv.CLICKED_BYLINE_SSR_MARK))
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'AnalyticsButton',
                        source: 'viewPageScreen',
                        objectId: contentId,
                        attributes: {
                            from: 'fromByline',
                            isSSR: wasComponentSSRed,
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
                break;
            case (0, $aXes4.SSREvent).FOCUS:
            case (0, $aXes4.SSREvent).HOVER:
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'hovered',
                        actionSubject: 'AnalyticsButton',
                        source: 'page',
                        objectId: contentId,
                        attributes: {
                            from: 'fromByline',
                            isSSR: wasComponentSSRed,
                            tabFocus: event === (0, $aXes4.SSREvent).FOCUS,
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
                break;
        }
    }, [
        contentId,
        createAnalyticsEvent,
        wasComponentSSRed,
        isLivePage
    ]);
    return {
        hideAnalyticsByLine: hideAnalyticsByLine,
        error: error ?? notifyUsersOnFirstViewError,
        loading: loading,
        //
        // Popup content
        //
        popupContent: ({ onClose: onClose, zIndex: zIndex })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $375484631ebaa373$export$86e005d79476c9b0), {
                contentId: contentId,
                onClose: onClose,
                referenceDate: dialogReferenceDate,
                selectedPill: selectedPill,
                onPillSelected: onPillSelected,
                requestBylineCountRefetch: triggerRefetch,
                zIndex: zIndex
            }),
        popupContentExperience: (0, $irVI7.ANALYTICS_DIALOG_EXPERIENCE),
        onPopupContentClose: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'dismissed',
                    actionSubject: 'analyticsPageModal',
                    actionSubjectId: 'analytics',
                    objectId: contentId,
                    source: 'analyticsPageModal'
                }
            }).fire();
        },
        //
        // Popup trigger
        //
        popupTrigger: ({ onClick: onClick })=>hideAnalyticsByLine || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da063c148ceb2f37$export$6875440beea453b6), {
                contentId: contentId,
                count: count,
                onClick: onClick,
                isBylineComponent: true,
                abbreviatePageViews: true,
                useBadgeStyle: true,
                testId: (0, $jS7pv.TestId).BYLINE
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Abqh.SetSSRPartialSuccess), {
                name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AnalyticsByLine
            })),
        popupTriggerExperience: (0, $irVI7.ANALYTICS_BYLINE_EXPERIENCE),
        onPopupTriggerSSREvent: onPopupTriggerSSREvent
    };
};
















































var $cJ0FD = parcelRequire("cJ0FD");


var $lHQAj = parcelRequire("lHQAj");

var $871f7364736dd219$exports = {};
$871f7364736dd219$exports = new URL("PageInsightsGraph.5c19c532.svg", import.meta.url).toString();


var $fd083e444dc33f14$exports = {};
$fd083e444dc33f14$exports = new URL("PageInsightsGraphDark.201ed636.svg", import.meta.url).toString();



var $cHKtk = parcelRequire("cHKtk");

const $a330263db479b3cb$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    title: {
        id: "change-edition.page-insights.title",
        defaultMessage: "Peek into trends with content insights"
    },
    body: {
        id: "change-edition.page-insights.body",
        defaultMessage: "See how well your content performs by tracking views when you upgrade to Confluence Standard."
    },
    learnMoreLink: {
        id: "change-edition.page-insights.learn-more-link",
        defaultMessage: "Explore insights"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a330263db479b3cb$var$ImageWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4jvau",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4jvau",
            __cmplp.className
        ])
    });
});
const $a330263db479b3cb$export$bc96611c4b9bd63d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)("pageInsights");
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($a330263db479b3cb$export$a7357cdd1f0b0168.title);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage($a330263db479b3cb$export$a7357cdd1f0b0168.body);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== children || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, children);
        $[4] = children;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            messageDescriptor: $a330263db479b3cb$export$a7357cdd1f0b0168.learnMoreLink,
            href: "https://support.atlassian.com/confluence-cloud/docs/view-insights-on-pages/"
        };
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a330263db479b3cb$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($871f7364736dd219$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($fd083e444dc33f14$exports))),
            alt: ""
        }));
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== loading || $[10] !== showRequestUpgradeButton || $[11] !== t1 || $[12] !== t3) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lHQAj.Card), {
            title: t1,
            body: t3,
            isLoadingRequestUpgradeButton: loading,
            showRequestUpgradeButton: showRequestUpgradeButton,
            learnMoreLink: t4,
            source: "pageInsights"
        }, t5);
        $[9] = loading;
        $[10] = showRequestUpgradeButton;
        $[11] = t1;
        $[12] = t3;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)('pageInsights');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lHQAj.Card), {
        title: formatMessage($a330263db479b3cb$export$a7357cdd1f0b0168.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage($a330263db479b3cb$export$a7357cdd1f0b0168.body), children),
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton,
        learnMoreLink: {
            messageDescriptor: $a330263db479b3cb$export$a7357cdd1f0b0168.learnMoreLink,
            href: 'https://support.atlassian.com/confluence-cloud/docs/view-insights-on-pages/'
        },
        source: "pageInsights"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a330263db479b3cb$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($871f7364736dd219$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($fd083e444dc33f14$exports))),
        alt: ""
    })));
};






var $1eaCJ = parcelRequire("1eaCJ");


var $1ytiN = parcelRequire("1ytiN");








const $efe344f41c0abadb$var$standardWrapperStyles = (0, $buxP3.xcss)({
    width: '350px'
});
const $efe344f41c0abadb$var$popupContentExperience = (0, $irVI7.ANALYTICS_DIALOG_UPSELL_EXPERIENCE);
const $efe344f41c0abadb$export$b7ad74bb8218e965 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isLivePage || $[2] !== isSiteAdmin) {
        t0 = (event)=>{
            if (event === (0, $aXes4.SSREvent).CLICK) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "pageInsightGate",
                    source: "pageInsights",
                    attributes: {
                        isSiteAdmin: isSiteAdmin,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isLivePage;
        $[2] = isSiteAdmin;
        $[3] = t0;
    } else t0 = $[3];
    const onPopupTriggerSSREvent = t0;
    let t1;
    if ($[4] !== onPopupTriggerSSREvent) {
        t1 = {
            hideAnalyticsByLine: false,
            loading: false,
            popupContent: $efe344f41c0abadb$var$_temp,
            popupContentExperience: $efe344f41c0abadb$var$popupContentExperience,
            popupTrigger: $efe344f41c0abadb$var$_temp2,
            onPopupTriggerSSREvent: onPopupTriggerSSREvent
        };
        $[4] = onPopupTriggerSSREvent;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const onPopupTriggerSSREvent = (0, $cozmU.useCallback)((event)=>{
        if (event === (0, $aXes4.SSREvent).CLICK) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'pageInsightGate',
                source: 'pageInsights',
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        isLivePage
    ]);
    return {
        hideAnalyticsByLine: false,
        loading: false,
        //
        // Popup content
        //
        popupContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                as: "section",
                xcss: $efe344f41c0abadb$var$standardWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a330263db479b3cb$export$bc96611c4b9bd63d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: $efe344f41c0abadb$var$popupContentExperience
            }))),
        popupContentExperience: $efe344f41c0abadb$var$popupContentExperience,
        //
        // Popup trigger
        //
        popupTrigger: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($efe344f41c0abadb$var$PopupTrigger, {
                onClick: onClick,
                abbreviatePageViews: true,
                useBadgeStyle: true
            }),
        onPopupTriggerSSREvent: onPopupTriggerSSREvent
    };
};
const $efe344f41c0abadb$var$i18n = (0, $kSwu1.defineMessages)({
    byLineUpsellText: {
        id: "confluence-analytics.byLineUpSell.buttonText",
        defaultMessage: "See how many people viewed this"
    },
    byLineAbbreviatedUpsellText: {
        id: "confluence-analytics.abbreviatedByLineUpSell.buttonText",
        defaultMessage: "See views"
    }
}); // Below Icon and Button styles are copied from @atlassian/analytics-byline to keep the styles consistent
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efe344f41c0abadb$var$AnalyticsIconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2hwx1b66 _s7n4nkob",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2hwx1b66 _s7n4nkob",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efe344f41c0abadb$var$ByLineButtonWrapperWithDot = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06azsu _p7f0u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06azsu _p7f0u2gc",
            __cmplp.className
        ])
    });
});
const $efe344f41c0abadb$var$PopupTrigger = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { abbreviatePageViews: abbreviatePageViews, onClick: onClick, useBadgeStyle: useBadgeStyle } = props;
    const BylineButtonWrapper = abbreviatePageViews ? (0, $3izAL.default) : $efe344f41c0abadb$var$ByLineButtonWrapperWithDot;
    const t0 = abbreviatePageViews ? $efe344f41c0abadb$var$i18n.byLineAbbreviatedUpsellText : $efe344f41c0abadb$var$i18n.byLineUpsellText;
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t0);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const analyticsBylineUpsellMessage = t1;
    let t2;
    if ($[2] !== analyticsBylineUpsellMessage || $[3] !== onClick || $[4] !== useBadgeStyle) {
        t2 = !useBadgeStyle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            onClick: onClick,
            appearance: "subtle-link",
            style: {
                fontWeight: "unset"
            },
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($efe344f41c0abadb$var$AnalyticsIconWrapper, {
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
            label: ""
        })), analyticsBylineUpsellMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13cb67b7495370c1$export$f2bb8dd0d057d45f), {
            onClick: onClick,
            message: analyticsBylineUpsellMessage,
            iconLabel: ""
        });
        $[2] = analyticsBylineUpsellMessage;
        $[3] = onClick;
        $[4] = useBadgeStyle;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== BylineButtonWrapper || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BylineButtonWrapper, null, t2);
        $[6] = BylineButtonWrapper;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const { abbreviatePageViews: abbreviatePageViews, onClick: onClick, useBadgeStyle: useBadgeStyle } = props;
    const BylineButtonWrapper = abbreviatePageViews ? (0, $3izAL.default) : $efe344f41c0abadb$var$ByLineButtonWrapperWithDot;
    const analyticsBylineUpsellMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), abbreviatePageViews ? $efe344f41c0abadb$var$i18n.byLineAbbreviatedUpsellText : $efe344f41c0abadb$var$i18n.byLineUpsellText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BylineButtonWrapper, null, !useBadgeStyle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: onClick,
        appearance: "subtle-link",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            fontWeight: 'unset'
        },
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($efe344f41c0abadb$var$AnalyticsIconWrapper, {
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
        label: ""
    })), analyticsBylineUpsellMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13cb67b7495370c1$export$f2bb8dd0d057d45f), {
        onClick: onClick,
        message: analyticsBylineUpsellMessage,
        iconLabel: ""
    }));
};
function $efe344f41c0abadb$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "section",
        xcss: $efe344f41c0abadb$var$standardWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a330263db479b3cb$export$bc96611c4b9bd63d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: $efe344f41c0abadb$var$popupContentExperience
    })));
}
function $efe344f41c0abadb$var$_temp2(t0) {
    const { onClick: onClick } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($efe344f41c0abadb$var$PopupTrigger, {
        onClick: onClick,
        abbreviatePageViews: true,
        useBadgeStyle: true
    });
}


const $a7ba582f45dae8f3$export$eddd987235013fb3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let args;
    let skip;
    if ($[0] !== t0) {
        ({ skip: skip, ...args } = t0);
        $[0] = t0;
        $[1] = args;
        $[2] = skip;
    } else {
        args = $[1];
        skip = $[2];
    }
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[3] !== edition || $[4] !== skip) {
        t1 = (0, $auSj5.isEditionAllowed)(edition) && !skip;
        $[3] = edition;
        $[4] = skip;
        $[5] = t1;
    } else t1 = $[5];
    const isNonUpsell = t1;
    const t2 = !isNonUpsell;
    let t3;
    if ($[6] !== args || $[7] !== t2) {
        t3 = {
            ...args,
            skip: t2
        };
        $[6] = args;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const nonUpsellPopup = (0, $c206d56742b29207$export$dee95a34dad96df6)(t3);
    if (!isNonUpsell) (0, $6mKj3.expVal)("confluence_insight_feature_gate_aa", "cohort", "not-enrolled");
    let t4;
    if ($[9] !== args || $[10] !== isNonUpsell) {
        t4 = {
            ...args,
            skip: isNonUpsell
        };
        $[9] = args;
        $[10] = isNonUpsell;
        $[11] = t4;
    } else t4 = $[11];
    const upsellPopup = (0, $efe344f41c0abadb$export$b7ad74bb8218e965)(t4);
    return isNonUpsell ? nonUpsellPopup : upsellPopup;
} : ({ skip: skip, ...args })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Show the non-upsell experience for paid editions i.e. the actual feature "Page insights"?
    const isNonUpsell = (0, $auSj5.isEditionAllowed)(edition) && !skip;
    const nonUpsellPopup = (0, $c206d56742b29207$export$dee95a34dad96df6)({
        ...args,
        skip: !isNonUpsell
    });
    // Fire A/A exposure for new page insights experiment for free editions
    if (!isNonUpsell) (0, $6mKj3.expVal)('confluence_insight_feature_gate_aa', 'cohort', 'not-enrolled');
    // Show the upsell experience for free editions
    const upsellPopup = (0, $efe344f41c0abadb$export$b7ad74bb8218e965)({
        ...args,
        skip: isNonUpsell
    });
    return isNonUpsell ? nonUpsellPopup : upsellPopup;
};


const $cafa771e0b866f24$var$AnalyticsByLineInternal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(68);
    const { contentId: contentId, contentAuthorId: contentAuthorId } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            ssrEventCaptureKey: (0, $jS7pv.SSR_EVENTS_CAPTURE_KEY),
            name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AnalyticsByLine
        };
        $[0] = t1;
    } else t1 = $[0];
    const { onSSRCapturedEvent: onSSRCapturedEvent, wasComponentSSRed: wasComponentSSRed, wasSSREventTriggered: wasSSREventTriggered } = (0, $c8111d736b2f6a35$export$3526fb65ade8d8b7)(t1);
    let t2;
    if ($[1] !== wasSSREventTriggered) {
        t2 = wasSSREventTriggered((0, $aXes4.SSREvent).CLICK);
        $[1] = wasSSREventTriggered;
        $[2] = t2;
    } else t2 = $[2];
    const [isPopupOpen, setPopupOpen] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[3] !== contentAuthorId || $[4] !== contentId || $[5] !== wasComponentSSRed) {
        t3 = {
            contentId: contentId,
            wasComponentSSRed: wasComponentSSRed,
            contentAuthorId: contentAuthorId
        };
        $[3] = contentAuthorId;
        $[4] = contentId;
        $[5] = wasComponentSSRed;
        $[6] = t3;
    } else t3 = $[6];
    const { error: error, loading: loading, popupContent: popupContent, popupContentExperience: popupContentExperience, onPopupContentClose: onPopupContentClose, popupTrigger: popupTrigger, popupTriggerExperience: popupTriggerExperience, onPopupTriggerSSREvent: onPopupTriggerSSREvent, hideAnalyticsByLine: hideAnalyticsByLine } = (0, $a7ba582f45dae8f3$export$eddd987235013fb3)(t3);
    let t4;
    let t5;
    if ($[7] !== wasComponentSSRed) {
        t4 = ()=>{
            if (wasComponentSSRed) (0, $jHois.CONTENT_ANALYTICS_VIEWERS_METRIC).markFMP((0, $9eE57.getMark)("CFP-63.ssr-ttr"));
        };
        t5 = [
            wasComponentSSRed
        ];
        $[7] = wasComponentSSRed;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t6;
    if ($[10] !== wasComponentSSRed) {
        t6 = ()=>{
            if (!wasComponentSSRed) setPopupOpen(false);
        };
        $[10] = wasComponentSSRed;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== contentId || $[13] !== wasComponentSSRed) {
        t7 = [
            contentId,
            wasComponentSSRed
        ];
        $[12] = contentId;
        $[13] = wasComponentSSRed;
        $[14] = t7;
    } else t7 = $[14];
    (0, $cozmU.useEffect)(t6, t7);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t8;
    let t9;
    if ($[15] !== contentId || $[16] !== createAnalyticsEvent) {
        t8 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "displayed",
                    actionSubject: "analytics",
                    actionSubjectId: contentId,
                    objectId: contentId,
                    source: "confluence-frontend"
                }
            }).fire();
        };
        t9 = [
            contentId,
            createAnalyticsEvent
        ];
        $[15] = contentId;
        $[16] = createAnalyticsEvent;
        $[17] = t8;
        $[18] = t9;
    } else {
        t8 = $[17];
        t9 = $[18];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[19] !== onPopupContentClose) {
        t10 = (...t11)=>{
            const args = t11;
            onPopupContentClose?.(...args);
            setPopupOpen(false);
        };
        $[19] = onPopupContentClose;
        $[20] = t10;
    } else t10 = $[20];
    const onPopupClose = t10;
    let t11;
    if ($[21] !== experienceTracker || $[22] !== onPopupTriggerSSREvent || $[23] !== popupContentExperience) {
        t11 = ()=>{
            onPopupTriggerSSREvent?.((0, $aXes4.SSREvent).CLICK);
            setPopupOpen(true);
            experienceTracker.start({
                name: popupContentExperience
            });
        };
        $[21] = experienceTracker;
        $[22] = onPopupTriggerSSREvent;
        $[23] = popupContentExperience;
        $[24] = t11;
    } else t11 = $[24];
    const onPopupTriggerClick = t11;
    let t12;
    let t13;
    if ($[25] !== onPopupTriggerClick || $[26] !== onSSRCapturedEvent) {
        t12 = ()=>{
            onSSRCapturedEvent((0, $aXes4.SSREvent).CLICK, onPopupTriggerClick);
        };
        t13 = [
            onSSRCapturedEvent,
            onPopupTriggerClick
        ];
        $[25] = onPopupTriggerClick;
        $[26] = onSSRCapturedEvent;
        $[27] = t12;
        $[28] = t13;
    } else {
        t12 = $[27];
        t13 = $[28];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    if ($[29] !== onPopupTriggerSSREvent) {
        t14 = ()=>{
            onPopupTriggerSSREvent?.((0, $aXes4.SSREvent).FOCUS);
        };
        $[29] = onPopupTriggerSSREvent;
        $[30] = t14;
    } else t14 = $[30];
    const onPopupTriggerFocus = t14;
    let t15;
    let t16;
    if ($[31] !== onPopupTriggerFocus || $[32] !== onSSRCapturedEvent) {
        t15 = ()=>{
            onSSRCapturedEvent((0, $aXes4.SSREvent).FOCUS, onPopupTriggerFocus);
        };
        t16 = [
            onSSRCapturedEvent,
            onPopupTriggerFocus
        ];
        $[31] = onPopupTriggerFocus;
        $[32] = onSSRCapturedEvent;
        $[33] = t15;
        $[34] = t16;
    } else {
        t15 = $[33];
        t16 = $[34];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    if ($[35] !== onPopupTriggerSSREvent) {
        t17 = ()=>{
            onPopupTriggerSSREvent?.((0, $aXes4.SSREvent).HOVER);
        };
        $[35] = onPopupTriggerSSREvent;
        $[36] = t17;
    } else t17 = $[36];
    const onPopupTriggerHover = t17;
    let t18;
    let t19;
    if ($[37] !== onPopupTriggerHover || $[38] !== onSSRCapturedEvent) {
        t18 = ()=>{
            onSSRCapturedEvent((0, $aXes4.SSREvent).HOVER, onPopupTriggerHover);
        };
        t19 = [
            onSSRCapturedEvent,
            onPopupTriggerHover
        ];
        $[37] = onPopupTriggerHover;
        $[38] = onSSRCapturedEvent;
        $[39] = t18;
        $[40] = t19;
    } else {
        t18 = $[39];
        t19 = $[40];
    }
    (0, $cozmU.useEffect)(t18, t19);
    let t20;
    let t21;
    if ($[41] !== error || $[42] !== experienceTracker || $[43] !== popupTriggerExperience) {
        t20 = ()=>{
            if (error) {
                if (popupTriggerExperience) experienceTracker.abort({
                    name: popupTriggerExperience,
                    reason: error.name
                });
                if ((0, $auSj5.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        t21 = [
            error,
            experienceTracker,
            popupTriggerExperience
        ];
        $[41] = error;
        $[42] = experienceTracker;
        $[43] = popupTriggerExperience;
        $[44] = t20;
        $[45] = t21;
    } else {
        t20 = $[44];
        t21 = $[45];
    }
    (0, $cozmU.useEffect)(t20, t21);
    let t22;
    let t23;
    if ($[46] !== error || $[47] !== experienceTracker || $[48] !== loading || $[49] !== popupTriggerExperience) {
        t22 = ()=>{
            if (!loading && !error && popupTriggerExperience) experienceTracker.succeed({
                name: popupTriggerExperience
            });
        };
        t23 = [
            error,
            experienceTracker,
            loading,
            popupTriggerExperience
        ];
        $[46] = error;
        $[47] = experienceTracker;
        $[48] = loading;
        $[49] = popupTriggerExperience;
        $[50] = t22;
        $[51] = t23;
    } else {
        t22 = $[50];
        t23 = $[51];
    }
    (0, $cozmU.useEffect)(t22, t23);
    let t24;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = (0, $jp2Q3.layers).dialog();
        $[52] = t24;
    } else t24 = $[52];
    const zIndex = t24;
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    let t25;
    if ($[53] !== Popup || $[54] !== error || $[55] !== hideAnalyticsByLine || $[56] !== isPopupOpen || $[57] !== onPopupClose || $[58] !== onPopupTriggerClick || $[59] !== onPopupTriggerFocus || $[60] !== onPopupTriggerHover || $[61] !== popupContent || $[62] !== popupTrigger || $[63] !== popupTriggerExperience || $[64] !== renderServerPlaceholder || $[65] !== ssrPlaceholderIdProp || $[66] !== wasComponentSSRed) {
        t25 = !hideAnalyticsByLine ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, popupTriggerExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: popupTriggerExperience
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
            testId: "analytics-by-line-popup",
            isOpen: isPopupOpen,
            onClose: onPopupClose,
            placement: "bottom-start",
            trigger: (props)=>{
                const { "aria-expanded": _, ...triggerProps } = props;
                const trigger = popupTrigger({
                    ...props,
                    onClick: onPopupTriggerClick
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    ...triggerProps,
                    onFocus: onPopupTriggerFocus,
                    onMouseOver: onPopupTriggerHover,
                    "data-vc": "analytics-byline-wrapper",
                    ...ssrPlaceholderIdProp
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                    metric: (0, $jHois.CONTENT_ANALYTICS_VIEWERS_METRIC),
                    isCustomStart: !wasComponentSSRed
                }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                }), trigger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, trigger, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
                    metric: (0, $jHois.CONTENT_ANALYTICS_VIEWERS_METRIC)
                })));
            },
            content: (props_0)=>popupContent({
                    ...props_0,
                    zIndex: zIndex
                }),
            zIndex: zIndex,
            messageId: "confluence-analytics-analytics-by-line-popup",
            messageType: "transactional"
        }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b2bb0d910e43743$export$9bacd85795ebefc9), {
            zIndex: zIndex
        })) : null;
        $[53] = Popup;
        $[54] = error;
        $[55] = hideAnalyticsByLine;
        $[56] = isPopupOpen;
        $[57] = onPopupClose;
        $[58] = onPopupTriggerClick;
        $[59] = onPopupTriggerFocus;
        $[60] = onPopupTriggerHover;
        $[61] = popupContent;
        $[62] = popupTrigger;
        $[63] = popupTriggerExperience;
        $[64] = renderServerPlaceholder;
        $[65] = ssrPlaceholderIdProp;
        $[66] = wasComponentSSRed;
        $[67] = t25;
    } else t25 = $[67];
    return t25;
} : ({ contentId: contentId, contentAuthorId: contentAuthorId })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { onSSRCapturedEvent: onSSRCapturedEvent, wasComponentSSRed: wasComponentSSRed, wasSSREventTriggered: wasSSREventTriggered } = (0, $c8111d736b2f6a35$export$3526fb65ade8d8b7)({
        ssrEventCaptureKey: (0, $jS7pv.SSR_EVENTS_CAPTURE_KEY),
        name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AnalyticsByLine
    });
    const [isPopupOpen, setPopupOpen] = (0, $cozmU.useState)(wasSSREventTriggered((0, $aXes4.SSREvent).CLICK));
    const { error: error, loading: loading, popupContent: popupContent, popupContentExperience: popupContentExperience, onPopupContentClose: onPopupContentClose, popupTrigger: popupTrigger, popupTriggerExperience: popupTriggerExperience, onPopupTriggerSSREvent: onPopupTriggerSSREvent, hideAnalyticsByLine: hideAnalyticsByLine } = (0, $a7ba582f45dae8f3$export$eddd987235013fb3)({
        contentId: contentId,
        wasComponentSSRed: wasComponentSSRed,
        contentAuthorId: contentAuthorId
    });
    (0, $cozmU.useEffect)(()=>{
        if (wasComponentSSRed) // https://hello.atlassian.net/l/cp/942Xd6LH#Instrumenting-your-feature
        (0, $jHois.CONTENT_ANALYTICS_VIEWERS_METRIC).markFMP((0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    }, [
        wasComponentSSRed
    ]);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        if (!wasComponentSSRed) setPopupOpen(false);
    }, [
        contentId,
        wasComponentSSRed
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'displayed',
                actionSubject: 'analytics',
                actionSubjectId: contentId,
                objectId: contentId,
                source: 'confluence-frontend'
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const onPopupClose = (...args)=>{
        onPopupContentClose?.(...args);
        setPopupOpen(false);
    };
    const onPopupTriggerClick = (0, $cozmU.useCallback)(()=>{
        onPopupTriggerSSREvent?.((0, $aXes4.SSREvent).CLICK);
        setPopupOpen(true);
        experienceTracker.start({
            name: popupContentExperience
        });
    }, [
        experienceTracker,
        onPopupTriggerSSREvent,
        popupContentExperience
    ]);
    (0, $cozmU.useEffect)(()=>{
        onSSRCapturedEvent((0, $aXes4.SSREvent).CLICK, onPopupTriggerClick);
    }, [
        onSSRCapturedEvent,
        onPopupTriggerClick
    ]);
    const onPopupTriggerFocus = (0, $cozmU.useCallback)(()=>{
        onPopupTriggerSSREvent?.((0, $aXes4.SSREvent).FOCUS);
    }, [
        onPopupTriggerSSREvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        onSSRCapturedEvent((0, $aXes4.SSREvent).FOCUS, onPopupTriggerFocus);
    }, [
        onSSRCapturedEvent,
        onPopupTriggerFocus
    ]);
    const onPopupTriggerHover = (0, $cozmU.useCallback)(()=>{
        onPopupTriggerSSREvent?.((0, $aXes4.SSREvent).HOVER);
    }, [
        onPopupTriggerSSREvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        onSSRCapturedEvent((0, $aXes4.SSREvent).HOVER, onPopupTriggerHover);
    }, [
        onSSRCapturedEvent,
        onPopupTriggerHover
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            if (popupTriggerExperience) experienceTracker.abort({
                name: popupTriggerExperience,
                reason: error.name
            });
            if ((0, $auSj5.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        experienceTracker,
        popupTriggerExperience
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !error && popupTriggerExperience) experienceTracker.succeed({
            name: popupTriggerExperience
        });
    }, [
        error,
        experienceTracker,
        loading,
        popupTriggerExperience
    ]);
    const zIndex = (0, $jp2Q3.layers).dialog();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    return !hideAnalyticsByLine ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, popupTriggerExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: popupTriggerExperience
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        testId: "analytics-by-line-popup",
        isOpen: isPopupOpen,
        onClose: onPopupClose,
        placement: "bottom-start",
        trigger: (props)=>{
            const { 'aria-expanded': _, ...triggerProps } = props;
            const trigger = popupTrigger({
                ...props,
                onClick: onPopupTriggerClick
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...triggerProps,
                onFocus: onPopupTriggerFocus,
                onMouseOver: onPopupTriggerHover,
                "data-vc": "analytics-byline-wrapper",
                ...ssrPlaceholderIdProp
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                metric: (0, $jHois.CONTENT_ANALYTICS_VIEWERS_METRIC),
                // If we did SSR we want the start time to be the page start time.
                // If we did not SSR we want the start time to be now.
                isCustomStart: !wasComponentSSRed
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }), trigger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, trigger, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
                metric: (0, $jHois.CONTENT_ANALYTICS_VIEWERS_METRIC)
            })));
        },
        content: (props_0)=>popupContent({
                ...props_0,
                zIndex: zIndex
            }),
        zIndex: zIndex,
        messageId: "confluence-analytics-analytics-by-line-popup",
        messageType: "transactional"
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b2bb0d910e43743$export$9bacd85795ebefc9), {
        zIndex: zIndex
    })) : null;
};
const $cafa771e0b866f24$export$d0aef4d352cf8b14 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CC_ANALYTICS
})((0, $7aRa9.withFlags)($cafa771e0b866f24$var$AnalyticsByLineInternal));
module.exports["AnalyticsByLine"] = $cafa771e0b866f24$export$d0aef4d352cf8b14;

});


//# sourceMappingURL=AnalyticsByLine.72055af4.js.map
